import { z } from 'zod'

export const AdminHandleType = z.enum(['person', 'org', 'role'])
export type AdminHandleType = z.infer<typeof AdminHandleType>

export const AdminHandleListItem = z.object({
  id: z.number().int(),
  external_id: z.number().int().nullable().optional(),
  external_name: z.string().nullable().optional(),
  type: AdminHandleType,
  account_data: z.boolean(),
  email_verified: z.boolean(),
  phone_verified: z.boolean(),
  created: z.string().nullable().optional(),
  verification_deadline: z.string().nullable().optional(),
  account_id: z.number().int(),
  account_email: z.string()
})
export type AdminHandleListItem = z.infer<typeof AdminHandleListItem>

export const AdminDomainRef = z.object({
  id: z.number().int(),
  name: z.string()
})
export type AdminDomainRef = z.infer<typeof AdminDomainRef>

export const AdminHandleDetails = z.object({
  id: z.number().int(),
  external_id: z.number().int().nullable().optional(),
  external_name: z.string().nullable().optional(),
  type: AdminHandleType,
  account_data: z.boolean(),
  email_verified: z.boolean(),
  email_verified_at: z.string().nullable().optional(),
  phone_verified: z.boolean(),
  phone_verified_at: z.string().nullable().optional(),
  created: z.string().nullable().optional(),
  updated: z.string().nullable().optional(),
  imported_at: z.string().nullable().optional(),
  verification_deadline: z.string().nullable().optional(),
  account_id: z.number().int(),
  account_email: z.string(),
  owner_domains: z.array(AdminDomainRef).optional(),
  admin_domains: z.array(AdminDomainRef).optional(),
  name: z.string().optional(),
  org: z.string().nullable().optional(),
  street: z.string().optional(),
  city: z.string().optional(),
  postcode: z.string().optional(),
  state: z.string().optional(),
  country: z.string().optional(),
  phone: z.string().optional(),
  fax: z.string().nullable().optional(),
  email: z.string().optional()
})
export type AdminHandleDetails = z.infer<typeof AdminHandleDetails>
